import { Language } from '../../store/slices/language-slice';

interface LoginMessages {
  loginUser: {
    heading: (companyName: string) => string;
    subHeading: string;
    usernameLabel: string;
    passwordLabel: string;
    continueButton: string;
    forgotPasswordLink: string;
    resetPasswordHere: string;
    needAccount: string;
    getStarted: string;
    registerLink: string;
    passwordErrorLabel: string;
    supportErrorLabelBeforeEmail: string;
    supportErrorLabelAfterEmail: string;
    supportLockLabelBeforeEmail: string;
    supportLockLabelAfterEmail: string;
    userSignedUpWithPassword: string;
    ssoError: string;
  };
  loginTwoFactor: {
    heading: string;
    subHeading: string;
    twoFactorErrorMessage: string;
    havingTroubleLabel: string;
    supportLabelBeforeEmail: string;
    supportLabelAfterEmail: string;
    resetTwoFactorLink: string;
    supportErrorLabelBeforeEmail: string;
    supportErrorLabelAfterEmail: string;
    supportLockLabelBeforeEmail: string;
    supportLockLabelAfterEmail: string;
  };
  seo: {
    title: string;
    description: string;
    keywords: string;
  };
}

type Message = {
  [key in Language]: LoginMessages;
};

const messages: Message = {
  eng: {
    loginUser: {
      heading: (companyName: string) => `Log in to ${companyName}`,
      subHeading: 'Please enter your login details',
      usernameLabel: 'Email',
      passwordLabel: 'Password',
      continueButton: 'Continue →',
      forgotPasswordLink: 'Forgot your password?',
      resetPasswordHere: 'Reset it here',
      needAccount: 'Need an account?',
      getStarted: 'Get started',
      registerLink: 'Create account',
      passwordErrorLabel:
        'Your email or password is incorrect, please try again',
      supportErrorLabelBeforeEmail: 'If the problem persists please contact',
      supportErrorLabelAfterEmail:
        'if you are experiencing problems with logging in.',
      supportLockLabelBeforeEmail: 'If the problem persists please contact',
      supportLockLabelAfterEmail:
        'if you are experiencing problems with logging in.',
      userSignedUpWithPassword:
        'This user has already signed up with email and password',
      ssoError:
        'An unexpected error occurred with single sign on. Please try again later',
    },
    loginTwoFactor: {
      heading: 'Two-factor authentication',
      subHeading: 'Please enter your 2FA verification code',
      twoFactorErrorMessage: 'Incorrect 2FA code, please try again',
      havingTroubleLabel: 'Having trouble?',
      supportLabelBeforeEmail: 'Send us an email at',
      supportLabelAfterEmail:
        'or click on the chat button on the bottom right for assistance',
      supportErrorLabelBeforeEmail: 'If the problem persists please contact',
      supportErrorLabelAfterEmail:
        'if you are experiencing problems with logging in.',
      supportLockLabelBeforeEmail: 'If the problem persists please contact',
      supportLockLabelAfterEmail: '',
      resetTwoFactorLink: 'Reset 2FA',
    },
    seo: {
      title: 'Altify - Login',
      description:
        'Effortlessly invest in crypto with one of our Bundles. Investing has never been this easy.',
      keywords:
        'investing, investment platform, cryptocrurency, top 10 cryptocurrency, top cryptocurrency, top performing crypto, diversification, diversified investing',
    },
  },
};

export default messages;
